import { StorageIo } from 'src/Libs/flow/installation/forms'
import { parseControllerDevice } from '../device-parsers'
import { StorageControllerDto } from 'src/Libs/flow/installation/api'

export const parseStorageIo = (io: Nullable<StorageControllerDto>): StorageIo => {
  return {
    ...parseControllerDevice(io),

    nominalPower: io?.outputs?.[0]?.typeParameters?.nominalPower ?? '',
    deviceLinkId: io?.deviceLinkId ?? -1,
    storageDeviceLinkId: io.mediaParameters?.deviceLinkId ?? -1,
  }
}
